import { Pipe, PipeTransform } from '@angular/core';
import * as momentTz from 'moment-timezone';

@Pipe({
  name: 'dataHoraFusoLocal'
})
export class DataHoraFusoLocalPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      const fusoHorarioLocal = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return momentTz.tz(value, fusoHorarioLocal).format('DD/MM/YYYY HH:mm:ss');
    }
    return '';
  }
}
